<template>
  <div>
    <q-dialog v-model="coletar">
      <q-card class="column" style="width: 800px; max-width: 80vw">
        <q-card-section class="row">
          <p class="text-h4">Justificativa</p>
        </q-card-section>
        <q-separator />
        <q-card-section class="row justify-around">
          <p class="text-h5">{{ keycloak.tokenParsed.name }}</p>
          <p class="text-h6">{{ navigator }}</p>
        </q-card-section>

        <q-card-section class="row justify-center">
          <q-input
            class="col-xs-11"
            label="JUSTIFICATIVA NÃO E OBRIGATORIA"
            v-model="Justificativa"
            dense
            filled
            type="textarea"
          />
        </q-card-section>

        <q-card-section class="row justify-end">
          <q-btn
            color="white"
            class="q-mr-lg"
            text-color="primary"
            size="md"
            label="VOLTAR"
            @click="coletar = false"
          />
          <q-btn
            class="q-mr-lg"
            color="primary"
            size="md"
            text-color="white"
            label="SALVAR"
            @click="sendReposta"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { inject } from "vue";
export default {
  props: ["resposta", "watch"],
  setup(props) {
    const coletar = ref(false);
    const respostaValue = ref("");
    const keycloak = inject("keycloak");
    const Justificativa = ref("");
    const navigator = ref("");
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const sendReposta = async () => {
      try {
        await store.dispatch("cse/enviarResposta", {
          autTipo: "jwt",
          autValor: localStorage.token,
          resposta: respostaValue.value,
          equipamento: navigator.value,
          justificativa: Justificativa.value,
        });

        quasar.notify({
          message: "Resposta enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        coletar.value = false;
        router.push({ name: "cse-historico" });
      } catch (error) {
        quasar.notify({
          message: "Erro ao enviar resposta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        coletar.value = false;
      }
    };

    watch(
      () => props.watch,
      () => {
        respostaValue.value = props.resposta;
        coletar.value = true;
        navigator.value = window.navigator.platform;
      }
    );

    return {
      coletar,
      sendReposta,
      keycloak,
      Justificativa,
      navigator,
    };
  },
};
</script>
